export var getFormCoverImageUrl = function getFormCoverImageUrl(form) {
  var _form$thumbnail, _form$coverImage;

  var thumbnail = (_form$thumbnail = form.thumbnail) === null || _form$thumbnail === void 0 ? void 0 : _form$thumbnail.trim();

  if (thumbnail) {
    return thumbnail;
  }

  var coverImage = (_form$coverImage = form.coverImage) === null || _form$coverImage === void 0 ? void 0 : _form$coverImage.trim();

  if (coverImage) {
    return coverImage;
  }

  return undefined;
};